import { EDIT_PROFILE_SETTINGS } from "shared/api";
import { Field, Form, MediaField, Page, SubmitButton, TextAreaField, TextField } from "shared/react";
import { PROFILE_FORM_SCHEMA } from "shared/schema";
import { EarnedRewardField } from "../reward/RewardField.js";
import { callAPI } from "../util/api.js";
import { useItem } from "../util/db.js";
import { uploadMediaFile } from "../util/media.js";
import { USER } from "../util/user.js";

export function ProfileEditPage(): React.ReactElement {
	const profileItem = useItem("profile", USER.data.uid);
	return (
		<Page title="Edit profile">
			<header>
				<h1 className="smush">Edit profile</h1>
				<p className="color-quiet size-small smush">This information appears publically on your profile page and is used for searches.</p>
			</header>
			<Form schema={PROFILE_FORM_SCHEMA} data={profileItem.data} onSubmit={v => callAPI(EDIT_PROFILE_SETTINGS, v)}>
				<MediaField name="photo" uploader={uploadMediaFile} />
				<EarnedRewardField name="background" type="background" />
				<Field title="Details">
					<TextField name="name" />
					<div className="flex-row flex-stretch gap-hairline">
						<TextField name="location" mods="flex-half" />
						<TextField name="website" mods="flex-half" />
					</div>
				</Field>
				<TextAreaField name="about" rows={4} />
				<SubmitButton>Save profile</SubmitButton>
			</Form>
		</Page>
	);
}
